import React, { useEffect } from 'react';

import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';

import { PlanDetail } from 'src/components/PaperPlanDetail/PlanDetail';
import { IPlanProps } from 'src/types/IPaperPlan';

import { getPrefilledWeightsMap } from '../../AddPaperPlan/AddWeights/addWeightsUtils';
import { LoaderForBtn } from '../../ConfirmationModal';

export const PlanReview: React.FC<IPlanProps> = ({
    onPrevious,
    onCancel,
    onSubmit,
    isSubmitLoading,
    onSaveDraft,
    planValues,
    showRerunAlert,
    planWeights,
    handlePlanWeightsBusinessRulesChange
}: IPlanProps) => {
    // Prepopulate plan weights by applying business rules
    useEffect(() => {
        const preFilledPlanWeights = getPrefilledWeightsMap(planValues);
        handlePlanWeightsBusinessRulesChange(preFilledPlanWeights);
    }, []);

    return (
        <>
            <PlanDetail
                heading="Review and save"
                planValues={planValues}
                hasAlert={showRerunAlert}
                planWeights={planWeights}
            />

            <Column spacingInset="500 none none none">
                <Row alignmentHorizontal="end">
                    <Button type="link" onClick={onCancel} aria-label="Cancel plan">
                        Cancel
                    </Button>
                    <Button type="tertiary" onClick={onPrevious} aria-label="Go to previous step">
                        Previous
                    </Button>
                    {!planValues.isDraft ? null : (
                        <Button
                            disabled={!planValues.isDraft}
                            type="secondary"
                            onClick={onSaveDraft}
                            aria-label="Save draft"
                        >
                            Save draft
                        </Button>
                    )}
                    <Button type="primary" onClick={onSubmit} aria-label="Save changes" disabled={isSubmitLoading}>
                        {isSubmitLoading ? LoaderForBtn : 'Save changes'}
                    </Button>
                </Row>
            </Column>
        </>
    );
};
